module.exports = __webpack_public_path__ + "static/media/mw.b32dcf7d.webp";